// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__1m-eo","cell":"ColumnAccessor_cell___H_cS","firstCellAccent":"ColumnAccessor_firstCellAccent__4Q-D9"};